module.exports = __webpack_public_path__ + "static/img/1.f69e304.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/1.png
// module id = EzLW
// module chunks = 0